<div class="p-4">
  <app-ep-table [config]="config" [data]="offers$ | async" data-cy="offer-table" />
</div>
